var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "swiperEl", staticClass: "swiper" }, [
    _c(
      "div",
      { staticClass: "swiper-wrapper" },
      _vm._l(_vm.games, function (game) {
        return _c(
          "div",
          { key: game.id, staticClass: "swiper-slide" },
          [
            _c("router-link", {
              staticClass: "game",
              class: "game_" + _vm.getMultiplierRatio(game.winColor),
              attrs: {
                to: { name: _vm.wheelHistoryRouteName },
                "aria-label": "轮盘历史记录",
                title: _vm.getTooltipText(game.winColor),
              },
            }),
          ],
          1
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }